<template>
  <main
    data-component="error-page"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
    v-background-color="$store.getters['ui/getBackgroundColor']"
  >
    <MainHeader :hideTableNumber="true"/>
    <div data-element="error-header">
      <h3
        data-element="error-heading"
        v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
        v-color="this.$store.getters['ui/getPrimaryColor']"
        v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
        :style="{ fontSize: '20px' }"
      >
        {{ $store.getters['iOrderCore/getErrorHeading'] || `Error` }}
      </h3>
    </div>
    <div data-element="text-container">
      <span
        class="heading"
        data-size="sm"
        data-weight="bold"
        v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
      >
        {{ $store.getters['iOrderCore/getErrorMessage'] || `An error has occurred. Please go to the bar to order.` }}
      </span>
    </div>
    <btn
      text="Back"
      data-position="center"
      size="md"
      :fontStyle="{...this.$store.getters['ui/getBodyCopyFontDetail']('normal'), textSize:'18px'}"
      :backgroundColor="$store.getters['ui/getSecondaryColor']"
      @click.native="$router.go(-1)"
    >
      Try again
    </btn>
  </main>
</template>

<script>
  import Btn from '@/components/ui/Btn';
  import MainHeader from '@/components/ui/MainHeader';

  export default {
    name: 'error-page',
    data: () => {
      return {

      };
    },
    components: {
      MainHeader,
      Btn
    },
  };
</script>


<style lang="scss" scoped>
  @import '@/assets/scss/variables.scss';
  @import '@/assets/scss/helpers.scss';

  [data-component='error-page'] {
    height:100vh;
    [data-element='error-heading'] {
      padding-top:16px;
    }
    [data-element='text-container']{
      padding: 24px;
      text-align: center;
      span {
        display: flex;
        justify-content: center;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
      }
    }
  }
</style>
